import React, { useEffect, useRef, useState } from 'react'
import pen from '../../assets/food/pen.svg'
import refresh from '../../assets/food/refresh.svg'
import cooking from '../../assets/food/cooking.gif'
import foodReady from '../../assets/food/foodready.png'
import backBtn from '../../assets/food/backBtnn.svg'
import EllGreen from '../../assets/food/EllipseGreen.svg'
import EllYellow from "../../assets/food/yellowellipse.svg";
import EllEmpty from "../../assets/food/ElliEmpty.svg";
import {
  useLocation,
  useNavigate,
  useSearchParams,
  useParams
} from 'react-router-dom';
import axios from 'axios'
import * as appConstants from "../../constants/index";
import dassadLine from "../../assets/food/dass-line.svg";
import Navbar from '../common/navbar/Navbar'
import FbHeader from './component/FbHeader'
import { getResponsiveClasses } from './component/ResponsiveClasses'
import Footer from '../common/footer/Footer'
import { format } from 'date-fns'

const gaTagData = JSON.parse(localStorage.getItem("gaTagData"));
function formatDate(dateString) {
  const date = new Date(dateString);
  const options = { weekday: "short", day: "2-digit", month: "short" };
  return date.toLocaleDateString("en-US", options);
}

function formatTime(timeString) {
  const date = new Date(timeString); // Use timeString passed as an argument
  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;
  const formattedHours = hours < 10 ? "0" + hours : hours;
  const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
  const formattedTime = `${formattedHours}:${formattedMinutes} ${ampm}`;

  return formattedTime; // Return the formatted time
}

const TrackOderStatus = () => {
  const [loading, setLoading] = useState(false);
  const { booking_id } = useParams();
  const [orderStatusLoading, setOrderStatusLoading] = useState(false);
  const [fnbData, setFnbData] = useState([]);
  const [gaTagFire, setGaTagFire] = useState(true);
  const [pageErrMsg, setPageErrMsg] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [ticketData, setTicketData] = useState(null);

  // const initialLoad = useRef(true);
  // const [timerExpired, setTimerExpired] = useState(false);
  const [remainingTime, setRemainingTime] = useState({
    minutes: 0,
    seconds: 0,
  });
  const [expand, setExpand] = useState(false);
  const navigate = useNavigate();

  const authToken = "Bearer " + (sessionStorage.getItem("token") || " ");
  const viewstatus = localStorage.getItem("viewstatus");
  const location = useLocation();

  let [searchParams, setSearchParams] = useSearchParams();

  const { currentClasses, getWindowWidth } = getResponsiveClasses();
  localStorage.removeItem("orid");
  const handleExpand = () => {
    setExpand(!expand);
  };

  //   const getOrderTargetTime = (bookingId) => {
  //     const orders =
  //       JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
  //     const order = orders.find((o) => o.en_bid === bookingId);
  //     return order ? order.targetTime : null;
  //   };

  useEffect(() => {
    const handleBackNavigation = () => {
      if (location.pathname !== "/") {
        navigate("/?tab=food", { replace: true });
        //navigate("/", { replace: true });
      }
    };

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    window.addEventListener("popstate", handleBackNavigation);
    window.history.pushState(null, "", window.location.href);
    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };


  }, [navigate, location.pathname]);

  useEffect(() => {
    const { orderTakeOn, statusEndTime } = fnbData?.deliveryStatus || {};

    const targetTimeFromStorage = localStorage.getItem("targetTime");

    const parsedOrderTakeOn = orderTakeOn ? new Date(orderTakeOn).getTime() : null;
    const parsedStatusEndTime = targetTimeFromStorage || (statusEndTime ? new Date(statusEndTime).getTime() : null);

    if (!parsedStatusEndTime || (parsedOrderTakeOn && parsedOrderTakeOn >= parsedStatusEndTime)) {
      setRemainingTime({ minutes: 0, seconds: 0 });
      return;
    }

    if (!targetTimeFromStorage) {
      localStorage.setItem("targetTime", new Date(parseInt(parsedStatusEndTime)));
    }

    const updateRemainingTime = () => {
      const currentTime = new Date().getTime();
      const difference = new Date(parsedStatusEndTime).getTime() - currentTime;

      if (difference <= 0) {
        setRemainingTime({ minutes: 0, seconds: 0 });
        localStorage.setItem("remainingTime", JSON.stringify({ minutes: 0, seconds: 0 }));
        localStorage.removeItem("targetTime");
        clearInterval(intervalId);
      } else {
        const minutes = Math.floor(difference / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);
        setRemainingTime({ minutes, seconds });
        localStorage.setItem("remainingTime", JSON.stringify({ minutes, seconds }));
      }
    };

    const intervalId = setInterval(updateRemainingTime, 1000);
    updateRemainingTime();

    return () => clearInterval(intervalId);
  }, [fnbData]);

  useEffect(() => {
    const bookingId = searchParams.get("bookingid");

    if (!bookingId || !fnbData?.deliveryStatus?.orderStatus) return;

    const orders =
      JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];

    const updatedOrders = orders.map((order) =>
      order.en_bid === bookingId
        ? {
          ...order,
          currentStatus: fnbData.deliveryStatus.orderStatus,
          deliveryMode: fnbData.otherDetails?.deliveryMode || order.deliveryMode,
        }
        : order
    );

    localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));
  }, [
    searchParams,
    fnbData?.deliveryStatus?.orderStatus,
    fnbData?.otherDetails?.deliveryMode,
  ]);


  const steps = [
  { id: "order received", label: "Order Received" },
  { id: "order confirmed", label: "Order Confirmed" },

  {
    id: "preparing your order",
    altIds: ["ready for pickup"],
    label: "Preparing Your Order",
  },

  { id: "picked up", label: "Picked up by staff" },
  { id: "delivered", label: "Delivered" },
];

  localStorage.setItem("remainingTime", JSON.stringify(remainingTime));
  const autoRefreshTime = fnbData?.deliveryStatus ? fnbData?.deliveryStatus?.autoRefreshTime + "000" : 45000;
  const orderGetitems = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
  const onSeat = fnbData?.otherDetails?.deliveryMode === "ONSEAT";

  const handleRefreshClick = async (event) => {
    event.preventDefault();
    if (onSeat && !isDisabled && fnbData?.deliveryStatus?.orderStatus !== "Delivered" && orderGetitems.length > 0) {
      setIsRefreshing(true);
      setIsDisabled(true);
      try {
        await OrderStatusFnB();
      } catch (error) {
        console.error("Error refreshing order status:", error);
      } finally {
        setTimeout(() => setIsRefreshing(false), 400);
        setTimeout(() => setIsDisabled(false), autoRefreshTime);
      }
    }
  };

  const OrderStatusFnB = async () => {
    try {
      setOrderStatusLoading(true);
      const bookingId = searchParams.get("bookingid");
      const orderId = searchParams.get("code");
      const response = await axios.post(`${appConstants.base_url}v1/fnb/fnbDeliveryStatus`,
        {
          bookingId: ticketData?.en_bid,
          code: ticketData?.orderId,
        },
        {
          headers: {
            Authorization: authToken,
            "Content-Type": "application/json",
            chain: localStorage.getItem("theme") === "inoxTheme" ? "INOX" : "PVR",
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
          },
        }
      );
      if (response.data.result === "success") {
        setFnbData(response.data.output);
        setGaTagFire(false)

        if (gaTagFire && viewstatus !== "true") {
          // foodPurchaseGATag(response.data.output);
        }
      } else {
        console.error(response.data.msg);
        setPageErrMsg("Booking Not Found!");
      }
    } catch (error) {
      console.error("Error fetching FnB data:", error);
    } finally {
      setOrderStatusLoading(false);
    }
  };

 
  

    useEffect(() => {
    getTicketDetails(booking_id);
  }, []);

 const getTicketDetails = async (bookingId) => {
    try {
      setLoading(true);
      const postData = {
        bookingId: bookingId,
        // bookType: "",
        // theatreId: "200",
        // chain: "PVR"
      };

      const res = await axios.post(
        `${appConstants.base_url}v1/booking/ticketing/details/${bookingId}`, // ✅ bookingId in URL
        postData,
        {
          headers: {
            appVersion: appConstants.av,
            platform: appConstants.pt,
            country: appConstants.cname,
            "Content-Type": "application/json",
          },
        }
      );

      const dt = res.data;

      if (dt?.result === "success") {
        const ndt = dt.output;
        const themeVal = ndt.chain === "INOX" ? "inoxTheme" : "pvrTheme";
        localStorage.setItem("theme", themeVal);
        setTicketData(ndt);

      }
      else {
        setTicketData(null);
        swal({
          text: dt?.msg || "Something went wrong",
          timer: 3000,
          icon: "error",
          buttons: false,
        });
      }

    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    const cleanupOrders = () => {
      const currentTime = new Date().getTime();
      const orders =
        JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
      const validOrders = orders.filter((order) => {
        const targetTime = new Date(order.targetTime).getTime();
        return targetTime > currentTime;
      });

      localStorage.setItem(
        "prepareMultiOrderStatus",
        JSON.stringify(validOrders)
      );
    };

    cleanupOrders(); // Initial cleanup
    const cleanupInterval = setInterval(cleanupOrders, 60000);
    return () => clearInterval(cleanupInterval);
  }, []);

  
  useEffect(() => {
    let interval;  // Define interval outside fetchData to persist correctly

    const fetchData = async () => {
      const currentStatus = fnbData?.deliveryStatus?.orderStatus?.toLowerCase();
      const onSeat = fnbData?.otherDetails?.deliveryMode === "ONSEAT";
      localStorage.setItem("onSeatType", onSeat);

      if (currentStatus !== "delivered" && onSeat && orderGetitems.length > 0 && autoRefreshTime > 0) {
        await OrderStatusFnB();
        if (interval) clearInterval(interval);
        interval = setInterval(() => {
          OrderStatusFnB();
        }, autoRefreshTime);
      }
    };

    fetchData();

    return () => {
      clearInterval(interval);
    };
  }, [fnbData?.deliveryStatus?.orderStatus, fnbData?.otherDetails?.deliveryMode, autoRefreshTime, orderGetitems.length]);

  useEffect(() => {
    const bookingId = searchParams.get("bookingid");
    if (!bookingId) return;

    const initializeTimer = () => {
      const orders = JSON.parse(localStorage.getItem("prepareMultiOrderStatus")) || [];
      let targetTime;

      // Get orderTakeOn and statusEndTime from fnbData
      const { orderTakeOn, statusEndTime } = fnbData?.deliveryStatus || {};

      if (!orderTakeOn || !statusEndTime) {
        console.error("Missing orderTakeOn or statusEndTime in fnbData.");
        return;
      }

      const existingOrder = orders.find((order) => order.en_bid === bookingId);

      if (existingOrder) {
        // Update the existing order with the latest data from the API
        targetTime = new Date(statusEndTime); // Always get fresh targetTime from API
        existingOrder.targetTime = targetTime.toISOString();
        existingOrder.orderTaken = new Date(orderTakeOn).toISOString();
        existingOrder.currentStatus = fnbData?.deliveryStatus?.orderStatus || null;
        existingOrder.deliveryMode = fnbData?.otherDetails?.deliveryMode || null;
        existingOrder.foodItems = fnbData?.otherDetails?.foods || null;

        // Update the order in localStorage
        const updatedOrders = orders.map((order) =>
          order.en_bid === bookingId ? existingOrder : order
        );
        localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));
      } else {
        // Parse targetTime from statusEndTime
        targetTime = new Date(statusEndTime);

        // Save new order to localStorage
        const newOrder = {
          en_bid: bookingId,
          bookingId: fnbData?.otherDetails?.bookingId || null,
          targetTime: targetTime.toISOString(),
          orderTaken: new Date(orderTakeOn).toISOString(),
          currentStatus: fnbData?.deliveryStatus?.orderStatus || null,
          deliveryMode: fnbData?.otherDetails?.deliveryMode || null,
          foodItems: fnbData?.otherDetails?.foods || null,
        };

        localStorage.setItem("prepareMultiOrderStatus", JSON.stringify([...orders, newOrder]));
      }

      let timerInterval;

      // Update timer immediately and start interval
      const updateTimer = () => {
        if (!targetTime || isNaN(targetTime.getTime())) {
          console.error("Invalid targetTime:", targetTime);
          clearInterval(timerInterval);
          setRemainingTime({ minutes: 0, seconds: 0 });
          return;
        }

        const currentTime = Date.now();
        const timeRemaining = targetTime.getTime() - currentTime;

        if (timeRemaining <= 0) {
          setRemainingTime({ minutes: 0, seconds: 0 });

          // Remove expired order
          const updatedOrders = orders.filter((order) => order.en_bid !== bookingId);
          localStorage.setItem("prepareMultiOrderStatus", JSON.stringify(updatedOrders));

          clearInterval(timerInterval);
        } else {
          const minutes = Math.floor(timeRemaining / (1000 * 60));
          const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
          setRemainingTime({ minutes, seconds });
        }
      };

      // Start the timer
      updateTimer();
      timerInterval = setInterval(updateTimer, 1000);

      // Cleanup interval on unmount
      return () => clearInterval(timerInterval);
    };
    const cleanup = initializeTimer();
    return () => {
      if (cleanup) cleanup();
    };
  }, [searchParams, fnbData]);

useEffect(() => {
  if (!ticketData?.en_bid || !ticketData?.orderId) return;

  const initialData = async () => {
    setLoading(true);
    try {
      await OrderStatusFnB();
    } catch (error) {
      console.error("Error fetching order status:", error);
    } finally {
      setLoading(false);
    }
  };

  initialData();
}, [ticketData?.en_bid, ticketData?.orderId]);

  const getCurrentStepIndex = () => {
  const currentStatus =
    fnbData?.deliveryStatus?.orderStatus?.toLowerCase();

  const index = steps.findIndex(
    (step) =>
      step.id === currentStatus ||
      step.altIds?.includes(currentStatus)
  );

  if (index === -1) return 0;

  return Math.min(index + 1, steps.length - 1);
};

const getCompletedStepIndex = () => {
  const currentStatus =
    fnbData?.deliveryStatus?.orderStatus?.toLowerCase();

  return steps.findIndex(
    (step) =>
      step.id === currentStatus ||
      step.altIds?.includes(currentStatus)
  );
};

  const getStepIcon = (index) => {
    const currentIndex = getCurrentStepIndex();
    const completedIndex = getCompletedStepIndex();
    if (index <= completedIndex) return EllGreen;
    if (index === currentIndex) return EllYellow;
    return EllEmpty;
  };

  const getDeliveredStyle = (index) => {
    const currentIndex = getCurrentStepIndex();
    const completedIndex = getCompletedStepIndex();

    // Default (EllEmpty)
    let bg = "#fff";
    let fill = "#808190";

    // Active (EllYellow)
    if (index === currentIndex) {
      bg = "#ffcb05";
      fill = "#fff";
    }

    // Completed (EllGreen)
    if (index <= completedIndex) {
      bg = "#149752";
      fill = "#fff";
    }

    return {
      borderRadius: "50%",
      backgroundColor: bg,
      fill: fill,
    };
  };

  const isStepActive = (index) => {
    const currentIndex = getCurrentStepIndex();
    const completedIndex = getCompletedStepIndex();
    return index <= Math.max(currentIndex, completedIndex);
  };

  const getCurrentStatusText = () => {
    const currentIndex = getCurrentStepIndex();
    return steps[currentIndex].label;
  };

  const getStepTime = (index) => {
    if (!fnbData?.deliveryStatus) return "";
    const { orderTakeOn, startedOn, readyOn, deliveredOn } = fnbData.deliveryStatus;

    switch (index) {
      case 0:
      case 1:
        return formatTime(orderTakeOn);
      case 2:
        return startedOn ? formatTime(startedOn) : "";
      case 3:
        return readyOn ? formatTime(readyOn) : "";
      case 4:
        return deliveredOn ? formatTime(deliveredOn) : "";
      default:
        return "";
    }
  };

  useEffect(() => {
    const handlePopState = (event) => {
      if (!window.location.search.includes("?tab=food")) {
        navigate("/?tab=food", { replace: true });
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <>
      {getWindowWidth &&
        <div className="bg-white show-in-desktop-view" style={{ position: "sticky", top: "0", zIndex: "999" }}>
          <Navbar />
        </div>
      }
      <div className={currentClasses.fnbdeskdiv}>
        <div className={currentClasses.fnbdeskdivInn}>
          <div className="fb-os-main">
            <style>
              {`
								@keyframes spin {
									0% { transform: rotate(0deg); }
									100% { transform: rotate(360deg); }
								}
								.refreshing {
									animation: spin 1s linear infinite;								
								}
								.refresh-complete {
									animation: spin 0.4s linear 1;
								}
								.disabled {
									opacity: 0.5;
									cursor: not-allowed;
								}
							`}
            </style>
            {loading ? (
              <div className="loading-messagefnb">
                <h2>Loading...</h2>
              </div>
            ) : (
              <>
                <FbHeader headname="Order Status" addressShow={false} filterIndex={location?.state?.filterIndex} />
                <div className="fb-os-inn">
                  <div className="fb-os-coIDiv">
                    {(() => {
                      const deliveredStep = steps.some(step => step.label === "Delivered");
                      return deliveredStep ? (
                        <img className="fb-os-coImg" src={foodReady} alt="Food Ready" />
                      ) : (
                        <img className="fb-os-coImg" src={cooking} alt="Cooking" />
                      );
                    })()}
                  </div>
                  <div className="fb-os-about">
                    {pageErrMsg ? (
                      <div className="nodatamsg">{pageErrMsg}</div>
                    ) : fnbData?.otherDetails ? (
                      <>
                        <p className="fb-os-oi">
                          Booking ID:
                          <span> {fnbData?.otherDetails?.bookingId}</span>
                        </p>
                        {
                          <>
                            {/* {isRefreshing && <p>Refreshing order status...</p>} */}
                            <div
                              className={`fb-os-ref ${isDisabled ? "disabled" : ""
                                }`}
                              style={{
                                cursor: isDisabled ? "default" : "pointer",
                              }}
                              onClick={handleRefreshClick}
                            >
                              {onSeat ? (
                                fnbData?.deliveryStatus?.orderStatus !== "Delivered" && localStorage.getItem("targetTime") ? (
                                  <p>Deliver</p>
                                ) : (
                                  <p>Delivered</p>
                                )
                              ) : (
                                <p>Pickup from Counter</p>
                              )}
                              {onSeat && fnbData?.deliveryStatus?.orderStatus !== "Delivered" && localStorage.getItem("targetTime") && (
                                <img
                                  src={refresh}
                                  alt="Refresh"
                                  className={
                                    isRefreshing
                                      ? "refreshing"
                                      : "refresh-complete"
                                  }
                                />
                              )}
                            </div>

                            {onSeat ? (

                              <>
                                <div className="fb-os-seat">
                                  <p className="fb-os-audi">
                                    Audi Name:{" "}
                                    <span>{fnbData?.otherDetails?.audi}</span>
                                  </p>
                                  <p className="fb-os-audi">
                                    Seat No:{" "}
                                    <span>{fnbData?.otherDetails?.seats}</span>
                                  </p>
                                </div>
                                <div className="fb-os-seat">
                                  <p className="fb-os-pickup">
                                    Order Date: <br />
                                    <span>
                                      {formatDate(fnbData?.deliveryStatus ? fnbData?.deliveryStatus?.orderTakeOn : fnbData?.otherDetails?.showTime)}
                                    </span>
                                  </p>
                                  <p className="fb-os-pickup" style={{ textAlign: "right" }}>
                                    Order Time:<br />
                                    <span>
                                      {formatTime(fnbData?.deliveryStatus ? fnbData?.deliveryStatus?.orderTakeOn : fnbData?.otherDetails?.showTime)}
                                      {/* {formatTime(fnbData?.deliveryStatus?.orderTakeOn)} */}
                                    </span>
                                  </p>
                                </div>
                              </>
                            ) : (
                              <div className="fb-os-seat">
                                <p className="fb-os-pickup">
                                  Pick-up Date: <br />
                                  <span>
                                    {formatDate(fnbData?.otherDetails?.showTime)}
                                  </span>
                                </p>
                                <p className="fb-os-pickup" style={{ textAlign: "right" }}>
                                  Pick-up Time:<br />
                                  <span>
                                    {formatTime(
                                      fnbData?.otherDetails?.showTime
                                    )}
                                  </span>
                                </p>
                              </div>
                            )}
                            {onSeat && fnbData?.deliveryStatus?.orderStatus !== "DELIVERED" && localStorage.getItem("targetTime") && (
                              <>
                                <div className="preparTime">
                                  <div className="fb-os-pt-img">
                                    <img src={pen} alt="" />
                                    <p className="fb-pyo">
                                      {getCurrentStatusText()}
                                    </p>
                                  </div>
                                  <div className="rem-time">
                                    <p>
                                      {remainingTime.minutes
                                        .toString()
                                        .padStart(2, "0")}
                                      :
                                      {remainingTime.seconds
                                        .toString()
                                        .padStart(2, "0")}
                                    </p>
                                  </div>
                                </div>
                                {orderStatusLoading ? (
                                  <div className="loading-section">
                                    <h2>Loading...</h2>
                                  </div>
                                ) : (
                                  <div className="ste-fb-dyn">
                                    <div className="vertical-stepper">
                                      {steps.map((step, index) => {
                                        return (
                                        <div
                                          key={index}
                                          className={`step ${isStepActive(index) ? "active" : ""
                                            }`}
                                        >
                                            <div className="Fnbstep-icon" style={getDeliveredStyle(index)}>
                                              {step.label === "Delivered" ?
                                                <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M9 17C13.4183 17 17 13.4183 17 9C17 4.5817 13.4183 1 9 1C4.5817 1 1 4.5817 1 9C1 13.4183 4.5817 17 9 17ZM9 18C13.9706 18 18 13.9706 18 9C18 4.02945 13.9706 0 9 0C4.02945 0 0 4.02945 0 9C0 13.9706 4.02945 18 9 18Z" fill={getDeliveredStyle(index).fill} />
                                                  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.34746 11C6.12501 12.9159 7.55711 14 9.00001 14C10.4429 14 11.875 12.9159 12.6526 11H5.34746ZM9.00001 15C6.98096 15 5.23091 13.476 4.37096 11.25C4.36271 11.2286 4.35451 11.2071 4.34641 11.1856C4.12226 10.59 4.59991 10 5.23636 10H12.7637C13.4001 10 13.8778 10.59 13.6536 11.1856C13.6455 11.2071 13.6373 11.2286 13.6291 11.25C12.7691 13.476 11.0191 15 9.00001 15Z" fill={getDeliveredStyle(index).fill} />
                                                  <path d="M7.6511 8.22083C7.7161 8.04198 7.69665 7.82348 7.6428 7.62423C7.58665 7.41643 7.48325 7.19253 7.3376 6.98458C7.0473 6.56998 6.56585 6.18883 5.91545 6.16148C5.24205 6.13323 4.73885 6.56058 4.42885 7.01418C4.2716 7.24433 4.1547 7.49328 4.0814 7.72233C4.01005 7.94513 3.9722 8.17323 3.99715 8.35553C4.0087 8.44013 4.06265 8.51298 4.14015 8.54868C4.2177 8.58443 4.3081 8.57813 4.3799 8.53203C4.5796 8.40383 4.78945 8.22838 4.98335 8.06628C5.07165 7.99243 5.1567 7.92138 5.2359 7.85883C5.51705 7.63678 5.7358 7.51023 5.9172 7.50138C6.0895 7.49293 6.28865 7.59173 6.5395 7.77938C6.6292 7.84653 6.71625 7.91753 6.8064 7.99113C6.83855 8.01733 6.87105 8.04388 6.9042 8.07063C7.0261 8.16908 7.1559 8.27023 7.28675 8.34933C7.35075 8.38808 7.42875 8.39608 7.4993 8.37123C7.56985 8.34633 7.62555 8.29113 7.6511 8.22083ZM10.3065 8.22083C10.2415 8.04198 10.261 7.82348 10.3148 7.62423C10.371 7.41643 10.4744 7.19253 10.62 6.98458C10.9103 6.56998 11.3918 6.18883 12.0422 6.16148C12.7156 6.13323 13.2188 6.56058 13.5288 7.01418C13.6861 7.24433 13.8029 7.49328 13.8763 7.72233C13.9476 7.94513 13.9854 8.17323 13.9605 8.35553C13.9489 8.44013 13.895 8.51298 13.8175 8.54868C13.74 8.58443 13.6496 8.57813 13.5777 8.53203C13.3781 8.40383 13.1682 8.22838 12.9743 8.06628C12.886 7.99243 12.8009 7.92138 12.7217 7.85883C12.4406 7.63678 12.2218 7.51023 12.0404 7.50138C11.8682 7.49293 11.669 7.59173 11.4182 7.77938C11.3285 7.84653 11.2414 7.91753 11.1512 7.99113C11.1191 8.01733 11.0866 8.04388 11.0534 8.07063C10.9315 8.16908 10.8017 8.27023 10.6709 8.34933C10.6069 8.38808 10.5289 8.39608 10.4584 8.37123C10.3878 8.34633 10.3321 8.29113 10.3065 8.22083Z" fill={getDeliveredStyle(index).fill} />
                                                </svg>
                                                :
                                            <img
                                              src={getStepIcon(index)}
                                              alt=""
                                            />
                                              }
                                          </div>
                                          <div
                                            style={{
                                              color: isStepActive(index)
                                                ? "#000"
                                                : "#888",
                                            }}
                                            className={`step-label ${isStepActive(index)
                                              ? "active"
                                              : ""
                                              }`}
                                          >
                                            {step.label}
                                          </div>
                                        </div>
                                        )
                                      })}
                                    </div>
                                    <div className="step-times">
                                      {steps.map((_, index) => (
                                        <p
                                          style={{
                                            color: isStepActive(index)
                                              ? "#000"
                                              : "#888",
                                            fontWeight: isStepActive(index)
                                              ? "500"
                                              : "normal",
                                          }}
                                          key={index}
                                        >
                                          {getStepTime(index)}
                                        </p>
                                      ))}
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </>
                        }

                        <div className="fb-os-item">
                          <p
                            style={{ marginBottom: "10px" }}
                            className="fb-os-i-cinIP"
                          >
                            ORDER Summary
                          </p>
                          {fnbData?.otherDetails?.foods?.map((item) => (
                            <React.Fragment key={item.itemId}>
                              <div className="fb-os-i-outer">
                                <div className="fb-os-i-innstatus">
                                  {item?.foodType === 1 ? (
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect x="0.5" y="0.5" width="13" height="13" rx="1.5" stroke="#149752" />
                                      <circle cx="6.99984" cy="6.99935" r="4.08333" fill="#149752" />
                                    </svg>
                                  ) : item?.foodType === 0 ? (
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 12 12"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <rect x="0.961426" y="0.964844" width="10.0769" height="10.0769" rx="1.5" stroke="#87001B" />
                                      <path d="M9 8.80886H3L6.00011 3.18945L9 8.80886Z" fill="#87001B" />
                                    </svg>
                                  ) :
                                    <p className="emtyIcon"></p>
                                  }

                                  <div>
                                    <p className="fnbsta-iname">
                                      {item?.name?.toLowerCase()} x {item?.quantity}
                                    </p>

                                    {item?.addons?.length > 0 && (
                                      <em className="fnb-c-addons">
                                        Add ons:
                                        {item?.addons?.map((addon, index) => (
                                          <p className="cart-addonP" key={`addon-${index}`}>
                                            <span>
                                              {addon?.name?.toLowerCase()} x {addon?.quantity}
                                            </span>
                                            <span className="os-statusAdd">
                                              ₹{((Number(addon?.price) * addon?.quantity) / 100).toFixed(2)}
                                            </span>
                                          </p>
                                        ))}
                                      </em>
                                    )}
                                  </div>
                                </div>

                                <div className="os-itemprice">
                                  ₹{((item?.price * item?.quantity) / 100).toFixed(2)}
                                </div>
                              </div>
                            </React.Fragment>
                          ))}

                          <img
                            // style={{ marginTop: "10px" }}
                            src={dassadLine}
                            alt=""
                          />
                          <div
                            style={{ paddingTop: 5, marginTop: 10 }}
                            className="fb-os-i-outer"
                          >
                            <p className="fb-os-i-subamt">Sub Total</p>
                            <p
                              style={{ fontWeight: 600 }}
                              className="fb-os-i-subamt"
                            >
                              ₹{((fnbData?.otherDetails?.fbTotalPrice + fnbData?.otherDetails?.discount) / 100)?.toFixed(2)}
                            </p>
                          </div>
                          {fnbData?.otherDetails?.discount > 0 && (
                            <div className="fb-stdiv4 b1">
                              <p className="fb-stpII">Discount</p>
                              <p className="fb-stpII2">
                                -₹{(fnbData?.otherDetails?.discount / 100).toFixed(2)}
                              </p>
                            </div>
                          )}
                          <div
                            style={{
                              paddingBottom: 5,
                              marginBottom: 10,
                            }}
                            className="fb-os-i-outer"
                          >
                            <p className="fb-os-i-amt">Amount Paid</p>
                            <p
                              style={{ fontWeight: 600 }}
                              className="fb-os-i-amt"
                            >
                              ₹{(fnbData?.otherDetails?.fbTotalPrice / 100)?.toFixed(2)}
                            </p>
                          </div>
                        </div>
                        <div className="fb-os-i-cin">
                          <div className="fb-os-i-cinInn">
                            <p className="fb-os-i-cinIP">Cinema</p>
                            <p className="fb-os-i-cinIAdd">
                              {fnbData?.otherDetails?.theaterName}
                            </p>
                          </div>
                          <div className="fb-os-i-cinIOut">
                            <div
                              style={{ border: "none" }}
                              className="fb-os-i-cin"
                            >
                              <p className="fb-os-i-cinIP">Payment Mode</p>
                              <p className="fb-os-i-cinIAdd">
                                {
                                  fnbData?.otherDetails?.payMode
                                    ?.split(",")
                                    .pop()
                                    .split(":")[0]
                                }
                              </p>
                            </div>
                            <div
                              className="fb-os-i-cin"
                              style={{ border: "none" }}
                            >
                              <p
                                style={{ textAlign: "right" }}
                                className="fb-os-i-cinIP"
                              >
                                Date
                              </p>
                              <p className="fb-os-i-cinIAdd">
                                {formatDate(fnbData?.otherDetails?.createdAt)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="nodatamsg">Booking Not Found!</div>
                    )}
                  </div>
                </div>
                <div className="fb-pno-btns">
                  <button
                    onClick={() => {
                      navigate("/?tab=food");
                      let dataLayer = window["dataLayer"] || [];
                      dataLayer.push({
                        'event': 'food_place_new_order',
                      });
                    }}
                    className="fb-pno-btn"
                  >
                    Place New Order
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {getWindowWidth &&
        <Footer />
      }
    </>
  );
}

export default TrackOderStatus